<template>
  <span>
    <text-editor ref="textEditor" v-model="editorData"></text-editor>
  </span>
</template>
<script>
import TextEditor from "../TextEditor";

export default {
  props: { value: { type: String, required: false } },
  components: {
    TextEditor: TextEditor,
  },
  data() {
    return {
      editorData: "",
    };
  },
  methods: {
    refreshEditor(text) {
      this.$refs.textEditor.text = text;
    },
  },
  watch: {
    editorData(val) {
      this.$emit("input", val);
    },
  },
};
</script>
